import { TopToolbar, usePermissions, useTranslate } from 'react-admin';
import { CustomSelectColumnsButton } from '@/components/global/buttons/CustomSelectColumnsButton.jsx';
import ColumnsIcon from '@/assets/icons/columns-icon.svg?react';
import CustomToolbarActionsPopover from '@/components/global/buttons/CustomToolbarActionsPopover';
import CustomCreateButton from '@/components/global/buttons/CustomCreateButton.jsx';
import CustomExportButton from '@/components/global/buttons/CustomExportButton.jsx';
import { SearchFilterInput } from '@/components/global/filters/SearchFilterInput.jsx';
import CustomFilterButton from '@/components/global/filters/CustomFilterButton';

export const UserListActions = () => {
    const { isLoading, permissions } = usePermissions();
    const translate = useTranslate();
    if (isLoading) return null;

    return (
        <TopToolbar>
            <SearchFilterInput />
            <CustomFilterButton />
            <CustomSelectColumnsButton startIcon={<ColumnsIcon />} style={{ margin: '0px -4px' }} />
            {(permissions.isAdmin || permissions.isServiceMaster) && (
                <CustomToolbarActionsPopover>
                    <CustomCreateButton label={translate('resources.user.labels.createUser')} />
                    <CustomExportButton />
                </CustomToolbarActionsPopover>
            )}
        </TopToolbar>
    );
};
